"use client";

import { Action } from "@clover-web-lib-sprout/action";
import SomethingWentWrongImage from "../_icons/somethingWentWrong";
import { clearStorageOnError } from "@/utils/errorUtils";
import { buildScanToOrderSearchParams } from "@/utils/scanToOrderUtils";
import { useCookies } from "react-cookie";

export default function SomethingWentWrong() {
  const [cookies] = useCookies(["scanToOrderInfo"]);
  const { scanToOrderInfo } = cookies;
  const isScanToOrderFlow = !!scanToOrderInfo;

  const handleClick = () => {
    let s2oParams = "";
    clearStorageOnError();
    if (isScanToOrderFlow) {
      s2oParams = buildScanToOrderSearchParams(scanToOrderInfo);
    }
    window.location.href = !isScanToOrderFlow ? `/` : `/menu/all${s2oParams}`;
  };

  return (
    <div className="w-full flex flex-col items-center justify-center h-[60vh]">
      <SomethingWentWrongImage />
      <h2 className="text-[32px] leading-[40px] mt-[22px] mb-[22px]">
        {"Looks like something went wrong"}
      </h2>
      <p className="mb-[35px]">
        {"Sorry, we ran into a problem while trying to load this page."}
      </p>
      <div onClick={handleClick} style={{ cursor: "pointer" }}>
        <Action>{"Go to homepage"}</Action>
      </div>
    </div>
  );
}
